import { useEffect, useState } from "react";
import { getApiErrorMessage } from "../../../lib/result-codes";
import { getMerchantStatistics } from "../api/merchant.api";
import type { MerchantStatistics } from "../types/merchant.types";

export interface UseMerchantStatisticsState {
  data: MerchantStatistics | null;
  loading: boolean;
  error: string | null;
  refresh: () => void;
}

export function useMerchantStatistics(): UseMerchantStatisticsState {
  const [data, setData] = useState<MerchantStatistics | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const fetchData = async () => {
    try {
      setLoading(true);
      setError(null);
      const result = await getMerchantStatistics();
      setData(result);
    } catch (fetchError: unknown) {
      setError(getApiErrorMessage(fetchError, "Failed to load merchant statistics"));
      setData(null);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  return {
    data,
    loading,
    error,
    refresh: fetchData,
  };
}
